export const GET_CPFM_CATEGORIES = "GET_CPFM_CATEGORIES";
export const GET_CPFM_CATEGORY_CAREERS = "GET_CPFM_CATEGORY_CAREERS";
export const GET_CPFM_CATEGORY_BY_ID = "GET_CPFM_CATEGORY_BY_ID";
export const UPDATE_CPFM_CATEGORY = "UPDATE_CPFM_CATEGORY";
export const DELETE_CPFM_CATEGORY = "DELETE_CPFM_CATEGORY";
export const CREATE_CPFM_CATEGORY = "CREATE_CPFM_CATEGORY";
